import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallPlateauIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 19C22.03 19 21.4 14.65 21.07 12.32C20.41 7.74 19.73 3 16.55 3H7.46001C4.28001 3 3.60001 7.74 2.94001 12.32C2.60001 14.65 1.98001 19 1.01001 19C0.46001 19 0.0100098 19.45 0.0100098 20C0.0100098 20.55 0.46001 21 1.01001 21C3.71001 21 4.27001 17.11 4.92001 12.6C5.36001 9.57 6.02001 5 7.46001 5H16.55C18 5 18.66 9.58 19.09 12.6C19.74 17.1 20.3 21 23 21C23.55 21 24 20.55 24 20C24 19.45 23.55 19 23 19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallPlateauIcon.displayName = 'TsplatFallPlateauIcon';
